import { types } from './actions';

const initialState = {
  isFetchingLoginInfo: false,
  loginActivity: [],
  isLoggingOut: false,
};

const reducer = (state = initialState, action) => {
  const payload = action.payload;
  switch (action.type) {
    case types.INIT_LOGIN_INFO:
      return { ...state, isFetchingLoginInfo: true };
    case types.FETCH_LOGIN_INFO_SUCCESS:
      return {
        ...state,
        loginActivity: payload.loginActivity,
        isFetchingLoginInfo: false,
      };
    case types.FETCH_LOGIN_INFO_ERROR:
      return { ...state, isFetchingLoginInfo: false };
    case types.LOGOUT_ALL_SESSIONS_SUCCESS:
      return { ...state, isLoggingOut: true };
    case types.LOGOUT_ALL_SESSIONS_ERROR:
      return { ...state, isLoggingOut: false };
    default:
      return state;
  }
};

const getScope = (state) => state.modules.settings.userProfile.loginActivity;

export const getIsFetchingLoginInfo = (state) =>
  getScope(state).isFetchingLoginInfo;

export const getLoginActivity = (state) => getScope(state).loginActivity;

export const getIsLoggingOut = (state) => getScope(state).isLoggingOut;

export default reducer;
